import styled from 'styled-components';

export const OfferWallHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;
